import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import envDataConfig from '../../../EnvDataConfig/EnvDataConfig';
import NavMenuModel from '../../../models/NavMenuModel';
import NavToolbarModel from '../../../models/NavToolbarModel';
import FooterModel from '../../../models/FooterModel';
import IFavicon from '../../../interfaces/IFavicon';
import AccessRestrictedPageModel from '../../../models/AccessRestrictedPageModel';
import PageNotFoundPageModel from '../../../models/PageNotFoundPageModel';
import SomethingWentWrongPageModel from '../../../models/SomethingWentWrongPageModel';
import BannerAlertModel from '../../../models/BannerAlertModel';
import { REACT_APP_OCP_APIM_SUBSCRIPTION_KEY } from '../../../EnvDataConfig/_envSettings';

export const vystarApi = createApi({
  reducerPath: 'apiData',
  baseQuery: fetchBaseQuery({ baseUrl: `${envDataConfig.baseUrl}`, prepareHeaders: (headers) => {
    headers.set( 'Access-Control-Allow-Origin','*');
    headers.set('Content-Type','application/json');
    headers.set('method', "GET");
    headers.set('Ocp-Apim-Subscription-Key', envDataConfig.apimSubscriptionKey || REACT_APP_OCP_APIM_SUBSCRIPTION_KEY);
    return headers;
  }}),
  keepUnusedDataFor: envDataConfig.cacheGlobalTimeout / 1000,
  endpoints: (builder) => ({
    faviconRequest: builder.query<IFavicon[], null>({
      query: () => `Global/favicons?siteTag=${envDataConfig.SiteTag}`,
    }),
    alertRequest: builder.query<Array<BannerAlertModel>, null>({
      query: () => {
        let alertURL = `Global/alerts?siteTag=${envDataConfig.SiteTag}`
        if(envDataConfig.isTokenAccessRequired){
          alertURL += `&token=${envDataConfig.accessToken}`;
        }
        return alertURL;
      },
    }),
    toolbarRequest: builder.query<Array<NavToolbarModel>, null>({
      query: () => {
        let toolbarURL = `Global/toolbar?siteTag=${envDataConfig.SiteTag}`
        if(envDataConfig.isTokenAccessRequired){
          toolbarURL += `&token=${envDataConfig.accessToken}`;
        }
        return toolbarURL;
      },
    }),
    menuRequest: builder.query<Array<NavMenuModel>, null>({
      query: () => {
        let navigationURL = `Global/navigation?siteTag=${envDataConfig.SiteTag}`
        if(envDataConfig.isTokenAccessRequired){
          navigationURL += `&token=${envDataConfig.accessToken}`;
        }
        return navigationURL;
      },
    }),
    pageRequest: builder.query<Array<NavToolbarModel>, string>({
        query: (url) => {
          let pageURL = `Page/GetBySlugAndTag?slug=${url}&siteTag=${envDataConfig.SiteTag}`
          if(envDataConfig.isTokenAccessRequired){
            pageURL += `&token=${envDataConfig.accessToken}`;
          }
          return pageURL;
        },
        keepUnusedDataFor: envDataConfig.cachePageTimeout /1000,
    }),
    accessRestrictedRequest: builder.query<Array<AccessRestrictedPageModel>, string>({
      query: () => `global/accessrestricted?siteTag=${envDataConfig.SiteTag}`,
    }),
    errorRequest: builder.query<Array<SomethingWentWrongPageModel>, null>({
      query: () => {
        let errorURL = `Global/error?siteTag=${envDataConfig.SiteTag}`
        if(envDataConfig.isTokenAccessRequired){
          errorURL += `&token=${envDataConfig.accessToken}`;
        }
        return errorURL;
      },
    }),
    pageNotFoundRequest: builder.query<Array<PageNotFoundPageModel>, null>({
      query: () => {
        let pageNotFoundURL = `Global/pageNotFound?siteTag=${envDataConfig.SiteTag}`
        if(envDataConfig.isTokenAccessRequired){
          pageNotFoundURL += `&token=${envDataConfig.accessToken}`;
        }
        return pageNotFoundURL;
      },
    }),
    footerRequest: builder.query<Array<FooterModel>, null>({
      query: () => {
        let footerURL = `global/footer?siteTag=${envDataConfig.SiteTag}`
        if(envDataConfig.isTokenAccessRequired){
          footerURL += `&token=${envDataConfig.accessToken}`;
        }
        return footerURL;
      },
    }),
    topicByCategoryRequest: builder.mutation<any, any>({
      query: (data) => {
        return ({
          url: `Page/GetTopicsByCategory?siteTag=${envDataConfig.SiteTag}`,
          method: "POST",
          body: data,
        })
      },
    }),
    locations: builder.mutation<any, any>({
      query: (data) => {
        return ({
          url: `Page/Locations`,
          method: "POST",
          body: data,
        })
      },
    }),
  }),
})
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useMenuRequestQuery, useToolbarRequestQuery, usePageRequestQuery, useFooterRequestQuery, useFaviconRequestQuery, useLocationsMutation,
  useAccessRestrictedRequestQuery, usePageNotFoundRequestQuery, useErrorRequestQuery, useAlertRequestQuery, useTopicByCategoryRequestMutation} = vystarApi